module.exports = __webpack_public_path__ + "assets/img/4.06d2abf9.jpg";